import React, { useContext, useState, useEffect } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import LoadingOverlay from "./LoadingOverlay";
import NavbarWithWebSocket from "./NavbarWithWebSocket";
import Sidebar2 from "./Sidebar2";

const MainLayout = () => {
  const navigate = useNavigate();
  const { isLoading, isAuthenticated } = useContext(AuthContext);
  const [showLoading, setShowLoading] = useState(false);

  // Initialize sidebar state from localStorage or default to true if not found
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const savedState = localStorage.getItem("isSidebarOpen");
    return savedState !== null ? JSON.parse(savedState) : true;
  });

  // Save sidebar state to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("isSidebarOpen", JSON.stringify(isSidebarOpen));
  }, [isSidebarOpen]);

  // Add delay to loading overlay
  useEffect(() => {
    if (isLoading) {
      setShowLoading(true);
    } else {
      const timer = setTimeout(() => {
        setShowLoading(false);
      }, 700); // seconds delay
      return () => clearTimeout(timer); // Clean up timer on unmount
    }
  }, [isLoading]);

  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);

  // Function to expand sidebar
  const expandSidebar = () => setIsSidebarOpen(true);

  if (showLoading) return <LoadingOverlay />;

  if (!isAuthenticated) {
    navigate("/login", { replace: true });
    return null; // Prevent rendering until redirected
  }

  return (
    <div className="min-h-screen flex flex-col">
      <NavbarWithWebSocket
        isSidebarOpen={isSidebarOpen}
        onToggleSidebar={toggleSidebar}
      />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar2 isOpen={isSidebarOpen} onExpandSidebar={expandSidebar} />
        <main
          className={`flex-1 overflow-y-auto bg-gray-50 transition-margin duration-300 ${
            isSidebarOpen ? "ml-72" : "ml-20"
          } mt-20`}
        >
          <Outlet /> {/* Renders nested routes */}
        </main>
      </div>
    </div>
  );
};

export default MainLayout;